import { render, staticRenderFns } from "./CustomerGroupDetailsView.vue?vue&type=template&id=b1a2fa96&scoped=true"
import script from "./CustomerGroupDetailsView.vue?vue&type=script&lang=js"
export * from "./CustomerGroupDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a2fa96",
  null
  
)

export default component.exports